import {
    BaseEngineInitializer,
    type ISubsystem,
    UIBridgeSubsystem,
    type VisionClientConfig
} from '@akavirtual/deai-web-core';
import { CollaborationUIBridge } from '@/bridges/collaboration-ui-bridge';

export class CollaborationInitializer extends BaseEngineInitializer {
    public getSubsystems(config: VisionClientConfig): ISubsystem[] {
        const subsystems = super.getSubsystems(config);
        const filtered = subsystems.filter(sub => !(sub instanceof UIBridgeSubsystem));
        filtered.push(new CollaborationUIBridge());
        return filtered;
    }
}